import { render } from "./VehicleTruckTile.vue?vue&type=template&id=d280bcc4"
import script from "./VehicleTruckTile.vue?vue&type=script&lang=js"
export * from "./VehicleTruckTile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/furkanyesil/Projects/fair-mieten-mg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__